export default __webpack_public_path__ + "static/media/icici_pru.7be43c10.png";